module.exports = __webpack_public_path__ + "img/深泽布艺制品.e8962723.jpg";